import React, { useEffect, useState} from 'react';
import {
	useSelector, useDispatch
}from "react-redux"
import { Select, Row, Col, TreeSelect, Form } from 'antd';
import i18n from "./localization"
import {
	CustomSelect
}from '../../../components/CustomSelect'
import DeleteIcon from '../../../../public/deleteIcon.svg'
import { tableReportsActions } from '../../Management/TableReports/actions';

const ReportParameter = ({isRu, isColumn, number, reportId, parameter, onParameterChange, onParameterDelete, settingsEnum, disabled }) => {
  const dispatch = useDispatch()
  const [paramId, setParamId] = useState(parameter.paramId)
  const [paramValue, setParamValue] = useState(parameter.valueIds)
  const optionsList = useSelector((state)=>state.tableReportReducer)
  const [action, setAction] = useState({})
  const [options, setOptions] = useState(null)

  const [additionalSelectProps, setAdditionalSelectProps] = useState({  
      placeholder:  i18n.chooseParamValue[isRu],
  })

  useEffect(()=>{
    if(action.type != null)
      if(!optionsList[action.result]){
        dispatch(tableReportsActions[action.type]())
      }else{
        setOptions(
          ![5, 7, 9].includes(paramId) ? getOptions(optionsList[action.result])
                                       : optionsList[action.result]
        )
      }
  },[action])

  useEffect(()=>{
    if(parameter){
      handleChangeParamId(parameter.paramId)
      setParamValue(parameter.valueIds)
    }
  }, [parameter])

  useEffect(()=>{
    if(action.result && !optionsList[`${action.result}Loading`] && action.type != null){ 
        setOptions(
          ![5, 7, 9].includes(paramId) ? getOptions(optionsList[action.result])
                                       : optionsList[action.result]
        )
    }
  },[optionsList[`${action.result}Loading`]])

  const getOptions = (optionList) => {
    return optionList?.map((value)=> {
      return {
        label: isRu ? value.name
                    : value.nameBel
                      ? value.nameBel 
                      : value.name,
        value: value.id,
        disabled: value.disabled 
      }
    })
  }

  const handleChangeParamId = (id) => {
    setParamId(id)
    setOptions(null)
    setAdditionalSelectProps(getAdditionalSelectProps(id))
  }

  const getChildrens = (childList, parentName) => {
    return childList?.map((value)=> {
      const childrens = {
              title: `${isRu ? value.name
                          : value.nameBel
                            ? value.nameBel 
                            : value.name} (${parentName})`,
              value: value.id
            }
            if(value.children?.length > 0){
              childrens.children = getChildrens(value.children, isRu ? value.name
                                                                     : value.nameBel
                                                                        ? value.nameBel 
                                                                        : value.name)
            }
      return childrens
    })
  }

  const baseSelectProps = {
    key: `value${paramId}`,
    disabled: paramId == null || optionsList[`${action.result}Loading`] || disabled,
    allowClear: true,
    onChange: (val) => {
        setParamValue(val) 
        onParameterChange({
          paramId: paramId, 
          valueIds: Array.isArray(val) 
                    ? val.map((v) => {
                        return v.id ?? v
                      })
                    : [val]
        })
    },
    value: paramValue,
    placeholder:  i18n.chooseParamValue[isRu]
  }

  const getAdditionalSelectProps = (id) => {
      switch (id) {
        case 0: //Тип обращения
          setAction({
            type: "getAppealTypesListForReportGenerator",
            result: "appealTypesList"
          })
          return {  
            placeholder: i18n.appealTypePlaceholder[isRu]
          }
        case 1: //Форма подачи обращения
          setAction({
            type: "getAppealFormTypesListForReportGenerator",
            result: "appealFormTypesList"
          })
          return {  
            placeholder: i18n.appealFormTypePlaceholder[isRu]
          }
        case 2: //Вид обращения
          setAction({
            type: "getAppealViewTypesListForReportGenerator",
            result: "appealViewTypesList"
          })
          return {
            placeholder: i18n.appealViewTypePlaceholder[isRu]
          }
        case 3: // Тип заявителя
          setAction({
            type: "getApplicantTypesListForReportGenerator",
            result: "applicantTypesList"
          })
          return {
            placeholder: i18n.applicantTypePlaceholder[isRu]
          }
        case 4: //Темы
          setAction({
            type: "getThemesListForReportGenerator",
            result: "themesList"
          })
          return {  
            placeholder: i18n.themePlaceholder[isRu],
          }
        case 5: //Подтемы
          setAction({
            type: "getSubthemesListForReportGenerator",
            result: "subthemesList",
            valueName: ["theme", "subthemes"]
          })
          return { 
            placeholder: i18n.subthemePlaceholder[isRu],
          }
        case 6: //Статус обращения
          setAction({
            type: "getReOrgAppealStatusesListForReportGenerator",
            result: "reOrgAppealStatusesList"
          })
          return {  
            placeholder: i18n.reOrgAppealStatusPlaceholder[isRu]
          }
        case 7: //Место действия обращения 
          setAction({
            type: "getReOrgAppealTerritoriesListForReportGenerator",
            result: "reOrgAppealTerritoriesList",
            valueName: ["", "children"]
          })
          return {  
            placeholder: i18n.reOrgAppealTerritoriesPlaceholder[isRu],
          }
        case 8: //Регионы
          setAction({
            type: "getRegionsListForReportGenerator",
            result: "regionsList"
          })
          return { 
            placeholder: i18n.regionsPlaceholder[isRu],
          }
        case 9: //Районы
          setAction({
            type: "getDistrictsListForReportGenerator",
            result: "districtList",
            valueName: ["region", "districts"]
          })
          return {  
            placeholder: i18n.districtsPlaceholder[isRu],
          }
        case 10: // Города областного подчинения
          setAction({
            type: "getRegionCitiesListForReportGenerator",
            result: "regionCitiesList"
          })
          return { 
            placeholder: i18n.regionCitiesPlaceholder[isRu],
          }
        case 11: //Вышестоящие организации
          setAction({
            type: "getSuperiorOrgsListForReportGenerator",
            result: "superiorOrgsList"
          })
          return {  
            placeholder: i18n.superiorOrgsPlaceholder[isRu],
            multiple: false,
            treeCheckable: false,
            allowClear: false
          }
        case 12: //Лица проводившие личный прием
          setAction({
            type: "getReceptionPersonListForReportGenerator",
            result: "receptionPersonList"
          })
          return {  
            placeholder: i18n.receptionPersonPlaceholder[isRu]
          }
        case 13: //Решение по обращению
          setAction({
            type: "getControlCompleteStatusesListForReportGenerator",
            result: "controlCompleteStatusesList"
          })
          return {  
            placeholder: i18n.controlCompleteStatusesPlaceholder[isRu]
          }
    }
  }

  return (
    <Row gutter={16}>
      <Col span={3}>
        <label>
          {(isColumn ? i18n.columnNum[isRu] : i18n.rowNum[isRu]).format(number)}
        </label>
      </Col>
      <Col span={9}>
        <Form.Item 
          name={`${reportId}${isColumn ? "col" : "row"}Select${number}`}
          initialValue={paramId}
          rules={[{
            required: true,
            message: i18n.chooseParam[isRu]
          }]}>
          <CustomSelect 
            value={paramId}
            disabled={disabled}
            suffixIcon={null}
            onChange={id => {
                handleChangeParamId(id)
                onParameterChange({paramId: id, valueIds: []})
                setParamValue([])
            }}
            placeholder={i18n.chooseParam[isRu]}
            options = {getOptions(settingsEnum)}
          />
        </Form.Item>
      </Col>
      <Col span={!disabled ? 11 : 12}>
        <Form.Item 
          name={`${reportId}${isColumn ? "col" : "row"}ValueSelect${number}`}
          initialValue={paramValue}
          rules={[{
            required: true,
            message: i18n.chooseParamValue[isRu]
        }]}>
            <TreeSelect
              {...baseSelectProps} 
              multiple= {true}
              treeCheckable= {true}
              {...additionalSelectProps}
              treeDefaultExpandedKeys={['all_group']}
              treeData={ 
                additionalSelectProps?.treeCheckable == false
                ? options?.map((option) => {
                  return{  
                    title: option.label,
                    value: option.value,
                  }
                })
                : [{
                  title: i18n.all[isRu],
                  value: 'all_group',
                  children: 
                    [5, 7, 9].includes(paramId) 
                    ? options?.map((value)=>{
                      const mainValue = action.valueName[0] != "" ? value[action.valueName[0]] : value
                      const secondaryValue = value[action.valueName[1]]
                        return{  
                          title: isRu ? mainValue.name 
                                      : mainValue.nameBel ?? mainValue.name,
                          value: `${mainValue.id}_group`,
                          children: getChildrens(
                            secondaryValue, 
                            isRu ? mainValue.name 
                                : mainValue.nameBel ?? mainValue.name
                          )
                        }
                      })
                    : options?.map((option) => {
                        return{  
                          title: option.label,
                          value: option.value,
                        }
                    })
                }]
              }
              filterTreeNode  ={(searchValue, node) => {
                return node.title.toLowerCase().includes(searchValue.toLowerCase());
              }}
            /> 
        </Form.Item>
      </Col>
      <Col span={!disabled ? 1 : 0}>
      { !disabled &&
        <div className='crossImg'>
          <img src={ DeleteIcon }  onClick={onParameterDelete}/>
        </div>
      }
      </Col>
    </Row>
  );
};

export default ReportParameter;